import fetch from "auth/FetchInterceptor";

const FeedbacksService = {};

const feedbackEndpointPrefix = "/feedback";

FeedbacksService.getAllFeedbacks = async (params = {}) =>
  await fetch({
    url: `${feedbackEndpointPrefix}/getAll`,
    method: "GET",
    params,
  });

FeedbacksService.getFeedbackById = async (id) =>
  await fetch({
    url: `${feedbackEndpointPrefix}/getById/${id}`,
    method: "GET",
  });

FeedbacksService.updateFeedbackStatus = async (id, data) =>
  await fetch({
    url: `${feedbackEndpointPrefix}/updateStatus/${id}`,
    method: "PUT",
    data,
  });

FeedbacksService.deleteFeedbackById = async (id) =>
  await fetch({
    url: `${feedbackEndpointPrefix}/deleteById/${id}`,
    method: "DELETE",
  });

export default FeedbacksService;
